<script setup lang="ts">
import Role from '@/core/resources/Role'

defineProps({
  role: {
    type: Object as () => Role,
    required: true
  }
})
const selected = defineModel<boolean>()

const emit = defineEmits({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  delete: (role: Role) => true
})
</script>

<template>
  <tr :class="{ selected: selected }">
    <td>
      <input type="checkbox" v-model="selected" :disabled="role.name === 'Admin'" />
    </td>
    <td class="name-column">
      <span>
        {{ role.name }}
      </span>
    </td>

    <td class="actions-column" v-if="role.name !== 'Admin'">
      <router-link :to="{ name: 'edit-role', params: { id: role.name } }">
        <span class="material-symbols-outlined action edit"> edit </span>
      </router-link>
      <span class="material-symbols-outlined action delete" @click="emit('delete', role)"> delete </span>
    </td>
    <td v-else></td>
  </tr>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tableline.scss';
</style>
